// Lista completa de países en español
export const COUNTRIES = [
  { value: 'AF', label: 'Afganistán' },
  { value: 'AL', label: 'Albania' },
  { value: 'DE', label: 'Alemania' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguila' },
  { value: 'AQ', label: 'Antártida' },
  { value: 'AG', label: 'Antigua y Barbuda' },
  { value: 'SA', label: 'Arabia Saudí' },
  { value: 'DZ', label: 'Argelia' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaiyán' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahréin' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BE', label: 'Bélgica' },
  { value: 'BZ', label: 'Belice' },
  { value: 'BJ', label: 'Benín' },
  { value: 'BM', label: 'Bermudas' },
  { value: 'BY', label: 'Bielorrusia' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia y Herzegovina' },
  { value: 'BW', label: 'Botsuana' },
  { value: 'BR', label: 'Brasil' },
  { value: 'BN', label: 'Brunéi' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'BT', label: 'Bután' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Camboya' },
  { value: 'CM', label: 'Camerún' },
  { value: 'CA', label: 'Canadá' },
  { value: 'QA', label: 'Catar' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CY', label: 'Chipre' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoras' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo (Rep. Dem.)' },
  { value: 'KR', label: 'Corea del Sur' },
  { value: 'KP', label: 'Corea del Norte' },
  { value: 'CI', label: 'Costa de Marfil' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croacia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curazao' },
  { value: 'DK', label: 'Dinamarca' },
  { value: 'DM', label: 'Dominica' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egipto' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'AE', label: 'Emiratos Árabes Unidos' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'SK', label: 'Eslovaquia' },
  { value: 'SI', label: 'Eslovenia' },
  { value: 'ES', label: 'España' },
  { value: 'US', label: 'Estados Unidos' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Esuatini' },
  { value: 'ET', label: 'Etiopía' },
  { value: 'PH', label: 'Filipinas' },
  { value: 'FI', label: 'Finlandia' },
  { value: 'FJ', label: 'Fiyi' },
  { value: 'FR', label: 'Francia' },
  { value: 'GA', label: 'Gabón' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GD', label: 'Granada' },
  { value: 'GR', label: 'Grecia' },
  { value: 'GL', label: 'Groenlandia' },
  { value: 'GP', label: 'Guadalupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GF', label: 'Guayana Francesa' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GQ', label: 'Guinea Ecuatorial' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haití' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungría' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Irán' },
  { value: 'IQ', label: 'Irak' },
  { value: 'IE', label: 'Irlanda' },
  { value: 'BV', label: 'Isla Bouvet' },
  { value: 'IM', label: 'Isla de Man' },
  { value: 'CX', label: 'Isla de Navidad' },
  { value: 'NF', label: 'Isla Norfolk' },
  { value: 'IS', label: 'Islandia' },
  { value: 'KY', label: 'Islas Caimán' },
  { value: 'CC', label: 'Islas Cocos' },
  { value: 'CK', label: 'Islas Cook' },
  { value: 'FO', label: 'Islas Feroe' },
  { value: 'GS', label: 'Islas Georgias del Sur y Sandwich del Sur' },
  { value: 'HM', label: 'Islas Heard y McDonald' },
  { value: 'FK', label: 'Islas Malvinas' },
  { value: 'MP', label: 'Islas Marianas del Norte' },
  { value: 'MH', label: 'Islas Marshall' },
  { value: 'UM', label: 'Islas Menores Alejadas de EE.UU.' },
  { value: 'SB', label: 'Islas Salomón' },
  { value: 'TC', label: 'Islas Turcas y Caicos' },
  { value: 'VG', label: 'Islas Vírgenes Británicas' },
  { value: 'VI', label: 'Islas Vírgenes de EE.UU.' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italia' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japón' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordania' },
  { value: 'KZ', label: 'Kazajistán' },
  { value: 'KE', label: 'Kenia' },
  { value: 'KG', label: 'Kirguistán' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'LA', label: 'Laos' },
  { value: 'LS', label: 'Lesoto' },
  { value: 'LV', label: 'Letonia' },
  { value: 'LB', label: 'Líbano' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libia' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lituania' },
  { value: 'LU', label: 'Luxemburgo' },
  { value: 'MO', label: 'Macao' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MY', label: 'Malasia' },
  { value: 'MW', label: 'Malaui' },
  { value: 'MV', label: 'Maldivas' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MA', label: 'Marruecos' },
  { value: 'MQ', label: 'Martinica' },
  { value: 'MU', label: 'Mauricio' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'México' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldavia' },
  { value: 'MC', label: 'Mónaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Níger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NO', label: 'Noruega' },
  { value: 'NC', label: 'Nueva Caledonia' },
  { value: 'NZ', label: 'Nueva Zelanda' },
  { value: 'OM', label: 'Omán' },
  { value: 'NL', label: 'Países Bajos' },
  { value: 'PK', label: 'Pakistán' },
  { value: 'PW', label: 'Palaos' },
  { value: 'PS', label: 'Palestina' },
  { value: 'PA', label: 'Panamá' },
  { value: 'PG', label: 'Papúa Nueva Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Perú' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PF', label: 'Polinesia Francesa' },
  { value: 'PL', label: 'Polonia' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'GB', label: 'Reino Unido' },
  { value: 'CF', label: 'República Centroafricana' },
  { value: 'CZ', label: 'República Checa' },
  { value: 'MK', label: 'República de Macedonia' },
  { value: 'DO', label: 'República Dominicana' },
  { value: 'RE', label: 'Reunión' },
  { value: 'RW', label: 'Ruanda' },
  { value: 'RO', label: 'Rumania' },
  { value: 'RU', label: 'Rusia' },
  { value: 'EH', label: 'Sahara Occidental' },
  { value: 'WS', label: 'Samoa' },
  { value: 'AS', label: 'Samoa Americana' },
  { value: 'BL', label: 'San Bartolomé' },
  { value: 'KN', label: 'San Cristóbal y Nieves' },
  { value: 'SM', label: 'San Marino' },
  { value: 'MF', label: 'San Martín' },
  { value: 'PM', label: 'San Pedro y Miquelón' },
  { value: 'VC', label: 'San Vicente y las Granadinas' },
  { value: 'SH', label: 'Santa Elena' },
  { value: 'LC', label: 'Santa Lucía' },
  { value: 'ST', label: 'Santo Tomé y Príncipe' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leona' },
  { value: 'SG', label: 'Singapur' },
  { value: 'SX', label: 'Sint Maarten' },
  { value: 'SY', label: 'Siria' },
  { value: 'SO', label: 'Somalia' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'ZA', label: 'Sudáfrica' },
  { value: 'SD', label: 'Sudán' },
  { value: 'SS', label: 'Sudán del Sur' },
  { value: 'SE', label: 'Suecia' },
  { value: 'CH', label: 'Suiza' },
  { value: 'SR', label: 'Surinam' },
  { value: 'SJ', label: 'Svalbard y Jan Mayen' },
  { value: 'TH', label: 'Tailandia' },
  { value: 'TW', label: 'Taiwán' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TJ', label: 'Tayikistán' },
  { value: 'IO', label: 'Territorio Británico del Océano Índico' },
  { value: 'TF', label: 'Territorios Australes Franceses' },
  { value: 'TL', label: 'Timor Oriental' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad y Tobago' },
  { value: 'TN', label: 'Túnez' },
  { value: 'TM', label: 'Turkmenistán' },
  { value: 'TR', label: 'Turquía' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UA', label: 'Ucrania' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistán' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VA', label: 'Vaticano' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'WF', label: 'Wallis y Futuna' },
  { value: 'YE', label: 'Yemen' },
  { value: 'DJ', label: 'Yibuti' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabue' }
];

// Función para buscar países
export const searchCountries = (query: string) => {
  if (!query) return COUNTRIES;
  
  const normalizedQuery = query.toLowerCase().trim();
  
  return COUNTRIES.filter(country => 
    country.label.toLowerCase().includes(normalizedQuery) ||
    country.value.toLowerCase().includes(normalizedQuery)
  );
};

// Países más comunes para mostrar primero (específicamente para México)
export const POPULAR_COUNTRIES = [
  'MX', 'US', 'CA', 'ES', 'AR', 'CO', 'VE', 'PE', 'CL', 'EC', 'BO', 'PY', 'UY', 'CR', 'PA', 'GT', 'HN', 'SV', 'NI', 'CU', 'DO', 'PR'
];

export const getPopularCountries = () => {
  return COUNTRIES.filter(country => POPULAR_COUNTRIES.includes(country.value))
    .sort((a, b) => POPULAR_COUNTRIES.indexOf(a.value) - POPULAR_COUNTRIES.indexOf(b.value));
};

export const getCountryByCode = (code: string) => {
  return COUNTRIES.find(country => country.value === code);
};

export const getCountryByName = (name: string) => {
  return COUNTRIES.find(country => 
    country.label.toLowerCase() === name.toLowerCase()
  );
};